import React, { Component } from 'react';
import profileIcon from '../../../assets/images/profile.svg';
import CKPButton from '../../forms/Button';

class Profile extends Component {
    state = { menuOpen: false };

    _openMenu = () => this.setState({ menuOpen: true });
    _closeMenu = () => this.setState({ menuOpen: false });

    render() {
        const { user, isTimetable, logOut, selectPartner, selectedPartnerName, selectedPartner, partnerOptions } =
            this.props;
        return (
            user && (
                <React.Fragment>
                    <div onClick={this._openMenu} className="ckp-top-menu-profile rp-hidden-760-min">
                        <p className="ckp-top-menu-profile-name">
                            <img src={profileIcon} alt="Profile" />
                            <span>{(user.fullName || '').split(' ')[0]}</span>
                        </p>
                        {isTimetable && selectedPartnerName ? <p>as {selectedPartnerName}</p> : null}
                    </div>
                    {this.state.menuOpen && (
                        <div
                            onClick={this._closeMenu}
                            className="ckp-top-menu-profile-dropdown-overlay rp-hidden-760-min"
                        />
                    )}
                    {this.state.menuOpen && (
                        <div className="ckp-top-menu-profile-dropdown rp-hidden-760-min">
                            <div className="ckp-top-menu-profile-section">
                                <p className="u-bold">{user.fullName}</p>
                                <p>{user.email}</p>
                                <CKPButton onClick={logOut} className="is-red" label="Sign out" />
                            </div>
                            {isTimetable && partnerOptions && partnerOptions.length ? (
                                <React.Fragment>
                                    <span className="ckp-top-menu-profile-line" />
                                    <div>
                                        <h4 className="ckp-ts-h4 ckp-top-menu-profile-options-title">View lineup as</h4>
                                        <ul className="ckp-top-menu-profile-options">
                                            {partnerOptions.map(po => (
                                                <li
                                                    key={po.id}
                                                    className={`ckp-top-menu-profile-option ${
                                                        selectedPartner === po.id ? 'is-selected' : ''
                                                    }`}
                                                    onClick={() => selectPartner(po.id)}
                                                >
                                                    {po.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </React.Fragment>
                            ) : null}
                        </div>
                    )}
                </React.Fragment>
            )
        );
    }
}

export default Profile;
